<template>
  <v-container grid-list-xs>
    <ConfirmationDialog text="Confirma o cancelamento dos itens?" :invoices="invoicesToCancel" @accepted="cancel"
      @refused="invoicesToCancel = []">
    </ConfirmationDialog>
    <v-row justify="space-around">
      <v-dialog v-model="dialogReceipt" width="70%" scrollable :scrim="false" transition="dialog-bottom-transition"
        @closed="receiptClosed">
        <v-card>
          <v-card-text class="p-10">
            <div v-html="receiptContent"></div>
          </v-card-text>
          <v-card-actions class="justify-start">
            <v-tooltip location="bottom" text="Imprimir">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" icon variant="plain" density="compact" @click="printReceipt">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip location="bottom" text="Exportar PDF">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" icon variant="plain" density="compact" @click="downloadReceipt">
                  <v-icon>mdi-file-pdf-box</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="dialogReceipt = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-form :submit="submitSearch">
          <v-expansion-panels variant="accordion" v-model="filterPanel">
            <v-expansion-panel value="searchFiltersPanel" rounded="rounded-xl">
              <v-expansion-panel-title
                style="color:#000000 !important; background-color: #e0e0e0ff; opacity: 1 !important" v-ripple>
                <v-row style="opacity: 1 !important">
                  <v-col cols="12" sm="3">
                    <span class="v-card-title">Filtro de pesquisa</span>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="6" sm="2">
                    <DialogCreateBill v-if="hasFinancialAccess" :user="user" v-model="newBillRequest" :floatRight="true"
                      :hideButton="false" @created="createdObject" @updated="updatedObject"
                      @writeoff="initiateCheckout" />
                  </v-col>
                  <v-col cols="6" sm="2">
                    <!-- SIM, É ADMIN POIS ESTA VIEW é para ADMINS -->
                    <DialogCreateInvoice v-if="hasFinancialAccess" :user="user" v-model="newInvoiceRequest"
                      :floatRight="true" :hideButton="false" @created="createdObject" @updated="updatedObject"
                      @writeoff="initiateCheckout" />
                    <DialogWriteOff v-if="hasFinancialAccess" :user="user" v-model="checkout" :floatRight="true"
                      :hideButton="true" @created="createdWriteOff" />
                  </v-col>
                </v-row>
              </v-expansion-panel-title>
              <v-expansion-panel-text class="bg-grey-lighten-2">
                <v-row density="compact">
                  <v-col cols="12">
                    <AutocompleteSelectCashflowCategory :user="user" label="Categorias/Rubricas"
                      v-model="filters.cashflow_category_ids" :includeDisabled="true" :returnObject="false"
                      :multiple="true" />
                  </v-col>
                  <v-col cols="12" md="6" v-if="hasFinancialAccess">
                    <AutocompleteSelectSubGroup :user="user" label="Grupos/Tropas" v-model="filters.subgroup_ids"
                      :returnObject="false" :multiple="true" />
                  </v-col>
                  <v-col cols="12" md="6" v-if="hasFinancialAccess">
                    <AutocompleteSelectLegalPeople :user="user" label="Pessoas" v-model="filters.legal_people_ids"
                      :returnObject="false" :multiple="true" />
                  </v-col>
                  <v-col cols="12" md="4" sm="4">
                    <AutocompleteSelectInvoiceStatus label="Situação" :multiple="true" :small="true"
                      v-model="filters.statuses" />
                  </v-col>
                  <v-col cols="12" md="4" sm="4">
                    <AutocompleteSelectPaymentMethod label="Tipo de Pagamento" :multiple="true" :small="true"
                      :returnObject="false" show-disabled v-model="filters.payment_method_ids" />
                  </v-col>
                  <v-col cols="12" md="4" sm="4">
                    <v-select label="Tipo de Lançamento" clearable :multiple="false"
                      :items="['Recebimento', 'Pagamento']" v-model="filters.invoice_type" density="compact">
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" align-self="start">
                    <v-row align="start" density="compact">
                      <v-col cols="12" md="2">
                        <v-label>Vencimento</v-label>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field type="date" label="De" density="compact"
                          v-model="filters.due_date_from"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field type="date" label="Até" density="compact" v-model="filters.due_date_to">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="6" align-self="start">
                    <v-row align="start" density="compact">
                      <v-col cols="12" md="2">
                        <v-label>Pagamento</v-label>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field type="date" label="De" density="compact" v-model="filters.payment_date_from">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field type="date" label="Até" density="compact" v-model="filters.payment_date_to">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="9" sm="6">
                    <AutocompleteSelectGroup @selected="selectedGroup" v-if="hasAdminAccess" />
                  </v-col>
                  <v-col cols="12" md="3" sm="4">
                    <v-select :items="[50, 100, 200, 500]" v-model="filters.itemsPerPage" label="Resultados por página"
                      density="compact" hide-details></v-select>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-btn color="warning" @click="clearFilters()">
                    <v-icon class="mr-2">mdi-broom</v-icon>
                    <span v-if="mdAndUp">Limpar Pesquisa</span>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" @click="exportInvoices()">
                    <v-icon>mdi-file-excel-box</v-icon>
                    <span v-if="mdAndUp">Excel</span>
                  </v-btn>
                  <v-btn color="secondary" @click="downloadSearch">
                    <v-icon class="mr-2">mdi-file-pdf-box</v-icon>
                    <span v-if="mdAndUp">Download</span>
                  </v-btn>
                  <v-btn color="primary" type="submit">
                    <v-icon class="mr-2">mdi-magnify</v-icon>
                    <span v-if="mdAndUp">Pesquisar</span>
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-form>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-container>
              <v-row justify="space-between" align="start">
                <v-col cols="2">
                  <v-tooltip location="top" v-if="hasFinancialAccess">
                    <template v-slot:activator="{ props }">
                      <div v-bind="props">
                        <v-btn density="compact" :disabled="!selectedItemsPayable" color="secondary"
                          :icon="!mdAndUp" :variant="mdAndUp ? 'elevated' : 'text'"
                          @click="writeOffBatch(selectedObjects)">
                          <v-icon>mdi-inbox-arrow-down</v-icon>
                          <span v-if="mdAndUp">Dar Baixa ({{ selectedObjects.length }})</span>
                        </v-btn>
                      </div>
                    </template>
                    <span v-if="eventRestriction">Existe autorização de evento pendente</span>
                    <span v-else-if="!selectedItemsPayable">Existe item não pagável</span>
                    <span v-else>Dar baixa nos itens selecionados</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="2">
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props }">
                      <v-btn density="compact" v-bind="props"
                        :disabled="selectedObjects.length <= 0 || selectedObjects.some(o => !o.cancellable)"
                        color="secondary" :icon="!mdAndUp" :variant="mdAndUp ? 'elevated' : 'text'"
                        @click="invoicesToCancel = selectedObjects">
                        <v-icon>mdi-cancel</v-icon>
                        <span v-if="mdAndUp">Cancelar ({{ selectedObjects.length }})</span>
                      </v-btn>
                    </template>
                    <span>Cancelar os itens selecionados</span>
                  </v-tooltip>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="8" class="text-right">
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props }">
                      <v-btn icon density="compact" v-bind="props" variant="text">
                        <v-icon color="grey-lighten-1" @click="showSelectHeaders = !showSelectHeaders">
                          mdi-cog
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Configurar Cabeçalhos</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
              <v-row>
                <v-col cols="12" v-if="showSelectHeaders">
                  <v-select label="Campos da tabela" item-title="title" return-object :items="headers" hide-details
                    multiple clearable chips v-model="selectedHeaders"
                    @update:modelValue="saveSelectedHeaders"></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-data-table-server class="elevation-1" density="compact" v-model="selectedObjects"
            :items-per-page="filters.itemsPerPage" :headers="selectedHeaders" :items="lstObjects"
            :items-length="serverTable.total" item-selectable="selectable" :loading="requestingApi"
            :search="searchFilter" show-select return-object fixed-header hide-default-footer
            @update:options="loadItems">
            <template v-slot:bottom>
              <v-row>
                <v-col cols="8" lg="2" offset-lg="8" align-self="start">
                  <strong>Total</strong>
                </v-col>
                <v-col cols="4" lg="2" align-self="end">
                  <strong>{{ totalSum }}</strong>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div class="text-center pt-2">
                    <span>Mostrando os itens {{ serverTable.from }} até {{ serverTable.to }} de {{ serverTable.total
                      }}</span>
                    <v-pagination density="compact" v-model="serverTable.page" :length="serverTable.maxPage"
                      show-first-last-page></v-pagination>
                  </div>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.is_human="{ value }">
              <span>{{ value ? "PF" : "PJ" }}</span>
            </template>
            <template v-slot:item.type="{ value }">
              <v-chip :color="$INVOICE_TYPE_DIC[value]?.color || 'grey'">{{
                $INVOICE_TYPE_DIC[value]
                ? $INVOICE_TYPE_DIC[value].label
                : value
                }}
              </v-chip>
            </template>
            <template v-slot:item.method="row">
              <span>{{ calcPaymentMethod(row.item) }}</span>
            </template>
            <template v-slot:item.person="row">
              <span>{{ calcPerson(row.item) }}</span>
            </template>
            <template v-slot:item.category="row">
              <span>{{ calcCategory(row.item) }}</span>
            </template>
            <template v-slot:item.status="row">
              <v-chip :color="$INVOICE_STATUS_DIC[row.item.status]?.color || 'grey'">{{
                $INVOICE_STATUS_DIC[row.item.status]
                ? $INVOICE_STATUS_DIC[row.item.status].label
                : row.item.status
                }}</v-chip>
            </template>
            <template v-slot:item.payment_date="row">
              <span v-if="row.item.payment_date" :class="getTextColorClassFromInvoiceDueDate(row.item)">{{
                $moment.parseZone(row.item.payment_date).format("DD/MM/YYYY")
                }}</span>
            </template>
            <template v-slot:item.due_date="row">
              <span :class="getTextColorClassFromInvoiceDueDate(row.item)">{{
                $moment.parseZone(row.item.due_date).format("DD/MM/YYYY")
                }}</span>
            </template>
            <template v-slot:item.amount="row">
              <span>{{
                $filters.currency(getAmountFromInvoice(row.item), 'BRL')
                }}</span>
            </template>
            <template v-slot:item.cashier="row">
              <span>{{ getCashierListFromReceipt(row.item.receipt) || ''}}</span>
            </template>
            <template v-slot:item.actions="row">
              <v-menu>
                <template v-slot:activator="{ props }">
                  <v-btn icon variant="text" v-bind="props"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                </template>
                <v-list>
                  <v-list-item v-if="row.item.editable" @click="editInvoice(row.item)">
                    <v-list-item-title>
                      <v-icon color="primary" class="mr-2">mdi-pencil</v-icon>
                      Editar
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="row.item.status == $INVOICE_STATUS_DIC.PAID.value" @click="receipt(row.item)">
                    <v-list-item-title>
                      <v-icon color="primary" class="mr-2">mdi-eye</v-icon>
                      Ver recibo
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="hasFinancialAccess && $PAYABLE_INVOICE_STATUSES.includes(row.item.status)"
                    :disabled="shouldDisablePayment(row.item)" @click="initiateCheckout(row.item)">
                    <v-list-item-title>
                      <v-icon color="blue" class="mr-2">mdi-cash-fast</v-icon>
                      Dar baixa
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="shouldDisablePayment(row.item)">
                      Autorização pendente para este evento
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item v-if="hasFinancialAccess && row.item.cancellable" @click="invoicesToCancel = [row.item]">
                    <v-list-item-title>
                      <v-icon color="primary" class="mr-2">mdi-cancel</v-icon>
                      Cancelar
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table-server>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AutocompleteSelectLegalPeople from "@/components/AutocompleteSelectLegalPeople.vue";
import DialogWriteOff from "@/components/DialogWriteOff.vue";
import { useDisplay } from 'vuetify';
import AutocompleteSelectCashflowCategory from "../components/AutocompleteSelectCashflowCategory.vue";
import AutocompleteSelectGroup from "../components/AutocompleteSelectGroup.vue";
import AutocompleteSelectInvoiceStatus from "../components/AutocompleteSelectInvoiceStatus.vue";
import AutocompleteSelectPaymentMethod from "../components/AutocompleteSelectPaymentMethod.vue";
import AutocompleteSelectSubGroup from "../components/AutocompleteSelectSubGroup.vue";
import ConfirmationDialog from "../components/ConfirmationDialog.vue";
import DialogCreateBill from "../components/DialogCreateBill.vue";
import DialogCreateInvoice from "../components/DialogCreateInvoice.vue";
import api from '@/services'
export default {
  setup() {
    const { mdAndUp } = useDisplay();

    return { mdAndUp }
  },
  components: {
    AutocompleteSelectGroup,
    AutocompleteSelectSubGroup,
    AutocompleteSelectLegalPeople,
    AutocompleteSelectPaymentMethod,
    AutocompleteSelectInvoiceStatus,
    AutocompleteSelectCashflowCategory,
    ConfirmationDialog,
    DialogCreateInvoice,
    DialogCreateBill,
    DialogWriteOff,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      initialized: false,
      tab: 1,
      paymentMethods: [],
      headers: [
        { title: "ID", align: "start", key: "id", sortable: true },
        { title: "Tipo", align: "start", key: "type", sortable: false },
        { title: "Descrição", align: "start", key: "description", sortable: true },
        { title: "Categoria", align: "start", key: "category", sortable: true },
        { title: "Evento", align: "start", key: "event.name", sortable: true },
        { title: "Venc.", align: "end", key: "due_date", sortable: true },
        { title: "Pag.", align: "end", key: "payment_date", sortable: true },
        { title: "Situação", align: "start", key: "status", sortable: true },
        { title: "Forma", align: "start", key: "method", sortable: true },
        { title: "Nome", align: "start", key: "person", sortable: true },
        { title: "Valor", align: "end", key: "amount", sortable: true },
        { title: "Caixa", align: "start", key: "cashier", sortable: true },
        { title: "Ações", key: "actions", align: "end", sortable: false },
      ],
      selectedHeaders: [],
      showSelectHeaders: false,
      lstObjects: [],
      selectedObjects: [],
      invoicesToCancel: [],
      filterPanel: "searchFiltersPanel",
      filters: {
        withUser: true,
        special_filters: [],
        statuses: [],
        itemsPerPage: 1,
        orderBy: null,
        is_human: null,
        invoice_type: null,
        group_id: null,
        legal_people_ids: [],
        subgroup_ids: [],
        cashflow_category_ids: [],
        payment_method_ids: [],
        payment_date_from: null,
        payment_date_to: null,
        due_date_from: null,
        due_date_to: null
      },
      newInvoiceRequest: {
        invoice: {},
      },
      newBillRequest: {
        invoice: {},
      },
      checkout: {
        payment_method: {},
        payment_date: this.$moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
        invoices: [],
        invoice: {},
        invoices_ids: [],
        validation: {
          total: 0,
        },
      },
      dialogCreateEdit: false,
      searchFilter: null,
      serverTable: {
        total: 0,
        from: 0,
        to: 0,
        page: 1,
        maxPage: 1,
      },
      currentInvoice: null,
      receiptContent: '',
      dialogReceipt: false,
    };
  },
  created() {
    var vm = this;
    
    Promise.all([
      vm.loadParameters(),
      vm.loadPaymentMethods()
    ]);
  },
  mounted() { },
  activated() { },
  methods: {
    loadPaymentMethods() {
      const vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.paymentMethod.list()
            .then((result) => {
              vm.paymentMethods = result.data;
              resolve(result.data);
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "error",
                  text: err.message,
                });
              }
              reject(err);
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    calcPerson(invoice) {
      const vm = this;

      switch (invoice.type) {
        case vm.$INVOICE_TYPE_DIC.INVOICE.value:
          return invoice?.to?.name;
        case vm.$INVOICE_TYPE_DIC.BILL.value:
          return !api.storage.isGroupSelected() || api.storage?.selectedGroup()?.id === 777 ? invoice?.to?.name : invoice?.from?.name;
        case vm.$INVOICE_TYPE_DIC.SERVICE.value:
          return !api.storage.isGroupSelected() || api.storage?.selectedGroup()?.id === 777 ? invoice?.to?.name : invoice?.from?.name;
        default:
          return 'TIPO NÃO DEFINIDO ' + invoice.type;
      }
    },
    calcCategory(invoice) {
      return invoice?.categories?.length > 0 ? invoice.categories.sort((c1, c2) => c2.parent_category_id - c1.parent_category_id)[0].name : '';
    },
    calcPaymentMethod(invoice) {
      const vm = this;

      return invoice?.receipt != null ? vm.paymentMethods.find(pm => pm.id === invoice.receipt.payment_method_id)?.name : '';
    },
    editInvoice(invoice) {
      const vm = this;

      if (invoice?.type === vm.$INVOICE_TYPE_DIC.INVOICE.value) {
        if (!invoice.legal_person_from) {
          invoice.legal_person_from = invoice.from;
        }
        vm.newInvoiceRequest = {
          invoice: invoice
        };
      } else if (invoice?.type === vm.$INVOICE_TYPE_DIC.BILL.value) {
        if (!invoice.legal_person_to) {
          invoice.legal_person_to = invoice.to;
        }
        vm.newBillRequest = {
          invoice: invoice
        };
      } else {
        vm.$notify({
          type: 'warning',
          message: 'Lançamento não Editável'
        });
      }
    },
    getTextColorClassFromInvoiceDueDate(invoice) {
      var vm = this;
      let _class = "";
      if (invoice.status == vm.$INVOICE_STATUS_DIC.CANCELED.value) {
        _class = "";
      } else {
        let _dueDate = vm.$moment.parseZone(invoice.due_date).startOf("day");
        if (invoice.payment_date) {
          let _paymentDate = vm.$moment
            .parseZone(invoice.payment_date)
            .startOf("day");
          if (_dueDate < _paymentDate) {
            _class = "text-red";
          } else if (
            _dueDate.format("DD/MM/YYYY") == _paymentDate.format("DD/MM/YYYY")
          ) {
            _class = "text-orange";
          } else if (_dueDate > _paymentDate) {
            _class = "text-green";
          }
        } else {
          let _today = vm.$moment.parseZone().startOf("day");
          if (_dueDate < _today) {
            _class = "text-red";
          } else if (
            _dueDate.format("DD/MM/YYYY") == _today.format("DD/MM/YYYY")
          ) {
            _class = "text-orange";
          } else if (_dueDate > _today) {
            _class = "text-blue";
          }
        }
      }
      return _class;
      // if (invoice.payment_date) {
      //   let _dueDate = vm.$moment({
      //       year: new Date(invoice.due_date).getFullYear(),
      //       month: new Date(invoice.due_date).getMonth(),
      //       day: new Date(invoice.due_date).getDay(),
      //     }).startOf("day");
      //   let _paymentDate = vm.$moment({
      //           year: new Date(invoice.payment_date).getFullYear(),
      //           month: new Date(invoice.payment_date).getMonth(),
      //           day: new Date(invoice.payment_date).getDay(),
      //         }).startOf("day")

      //   let _bool = _dueDate < _paymentDate
      //     if (!_bool) {
      //       console.log(
      //         'for some reason, ',
      //         vm.$moment.parseZone(invoice.due_date).local().format("DD/MM/YYYY hh:mm:ss"),
      //         'IS NOT BEFORE',
      //         vm.$moment.parseZone(invoice.payment_date).local().format("DD/MM/YYYY hh:mm:ss"),
      //         )
      //     }
      //     return _bool
      // } else {
      //   return vm.$moment
      //     .parseZone({
      //       year: new Date(invoice.due_date).getFullYear(),
      //       month: new Date(invoice.due_date).getMonth(),
      //       day: new Date(invoice.due_date).getDay(),
      //     }).startOf("day")
      //     .isBefore(vm.$moment.parseZone().startOf("day"));
      // }
    },
    getCashierListFromReceipt(receipt) {
      const vm = this;

      if (receipt && receipt.movements && receipt.movements.length > 0) {
        return [...new Set(receipt.movements.map(m => m.cashier.name))].join(', ');      }
    },
    getAmountFromInvoice(invoice) {
      const vm = this;

      if (invoice.status === vm.$INVOICE_STATUS_DIC.PAID.value && invoice.paid_amount) {
        return invoice.paid_amount;
      } else {
        let _dueDate = vm.$moment.parseZone(invoice.due_date).startOf("day");
        let _today = vm.$moment.parseZone().startOf("day");
        let _amount = invoice.amount;
        if (_dueDate > _today) {
          _amount -= invoice.early_payment_discount || 0
        } else if (
          _dueDate.format("DD/MM/YYYY") == _today.format("DD/MM/YYYY")
        ) {
          _amount -= invoice.early_payment_discount || 0
        }
        return _amount
      }
    },
    shouldDisablePayment(invoice) {
      return invoice?.event && !invoice?.event?.authorizations?.map(ea => ea.invitee_id).includes(invoice.to.id);
    },
    createdWriteOff() {
      var vm = this;

      vm.selectedObjects = [];
      vm.submitSearch();
    },
    initiateCheckout(val) {
      var vm = this;

      if (Array.isArray(val)) {
        // vm.checkoutItems.push(...val)
        vm.checkout = {
          invoices: val,
          invoice: null,
          payment_method: null,
          payment_date: vm.$moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
          invoices_ids: [],
          validation: {
            total: 0,
          },
        };
      } else {
        // vm.checkoutItems.push(val)
        vm.checkout = {
          invoices: [],
          invoice: val,
          payment_method: null,
          payment_date: vm.$moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
          invoices_ids: [],
          validation: {
            total: 0,
          },
        };
      }
    },
    saveSelectedHeaders() {
      var vm = this;
      try {
        localStorage.setItem(
          "_invoice_list_headers",
          JSON.stringify(vm.selectedHeaders)
        );
      } catch (error) {
        console.error(error);
      }
    },
    writeOffBatch(invoices) {
      var vm = this;
      let _lstResult = [];
      invoices.forEach((invoice) => {
        if (vm.$PAYABLE_INVOICE_STATUSES.includes(invoice?.status)) {
          _lstResult.push(invoice);
        }
      });
      vm.initiateCheckout(_lstResult);
    },
    selectedGroup(group) {
      var vm = this;
      vm.filters.group_id = group?.id;
    },
    loadParameters() {
      var vm = this;
      let _itemsPerPage = localStorage["_invoices_itemsPerPage"];
      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 200);

      try {
        let _headers = localStorage["_invoice_list_headers"];
        vm.selectedHeaders = _headers ? JSON.parse(_headers) : vm.headers;
      } catch (error) {
        vm.selectedHeaders = vm.headers;
      }
    },
    clearFilters() {
      var vm = this;

      vm.searchFilter = null;
      vm.filters.orderBy = null;
      vm.filters.group_id = null;
      vm.filters.is_human = null;
      vm.filters.searchText = null;
      vm.filters.due_date_to = null;
      vm.filters.due_date_from = null;
      vm.filters.payment_date_to = null;
      vm.filters.payment_date_from = null;
      vm.filters.type = [];
      vm.filters.statuses = [];
      vm.filters.subgroup_ids = [];
      vm.filters.special_filters = [];
      vm.filters.payment_method_ids = [];
      vm.filters.legal_people_ids = [];
      vm.filters.cashflow_category_ids = [];
    },
    submitSearch(page) {
      var vm = this;

      vm.selectedObjects = [];
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.initialized = true;
        vm.serverTable.page = page || 1;
        return new Promise((resolve, reject) => {
          let _function =
            vm.hasFinancialAccess ? "listAdmin" : "myInvoices";
          api.invoice[_function](vm.filters, vm.serverTable.page)
            .then((result) => {
              vm.lstObjects = result?.data.map(o => {
                o['selectable'] = o.status !== vm.$INVOICE_STATUS_DIC.PAID.value && o.status !== vm.$INVOICE_STATUS_DIC.CANCELED.value;
                o['editable'] = o.status !== vm.$INVOICE_STATUS_DIC.PAID.value && o.status !== vm.$INVOICE_STATUS_DIC.CANCELED.value && (vm.hasAdminAccess || o.type !== vm.$INVOICE_TYPE_DIC.SERVICE.value);
                o['cancellable'] = vm.$PAYABLE_INVOICE_STATUSES.includes(o.status) && (vm.hasAdminAccess || o.type !== vm.$INVOICE_TYPE_DIC.SERVICE.value);
                return o;
              });
              vm.serverTable.total = result?.total;
              vm.serverTable.from = result?.from;
              vm.serverTable.to = result?.to;
              vm.serverTable.maxPage = result?.last_page;
              vm.$notify({
                type: "success",
                text: "Pesquisa concluída",
              });
              vm.filterPanel = "";
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    downloadSearch() {
      const vm = this;

      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.pdf.downloadInvoices(vm.filters)
            .then((result) => {
              // create file link inx browser's memory
              const href = URL.createObjectURL(result);

              // create "a" HTML element with href to file & click
              const link = document.createElement('a');
              link.href = href;

              link.setAttribute('download', `Lançamentos_${vm.$moment(new Date()).format("YYYYMMDD-HHmmss")}.pdf`); //or any other extension
              document.body.appendChild(link);
              link.click();

              // clean up "a" element & remove ObjectURL
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "error",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    exportInvoices() {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.excel.exportInvoices(vm.filters)
            .then((result) => {
              // create file link inx browser's memory
              const href = URL.createObjectURL(result);

              // create "a" HTML element with href to file & click
              const link = document.createElement('a');
              link.href = href;

              link.setAttribute('download', `Lançamentos_${vm.$moment(new Date()).format("YYYYMMDD-HHmmss")}.xlsx`); //or any other extension
              document.body.appendChild(link);
              link.click();

              // clean up "a" element & remove ObjectURL
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
              resolve(result);
            }).catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
              reject(err);
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    createdObject(val) {
      const vm = this;

      if (val && typeof val === 'object') {
        val = [...val];
      }

      vm.serverTable.total += val.length;
      vm.serverTable.to += val.length;
      vm.lstObjects = val.map(o => {
        o['selectable'] = o.status !== vm.$INVOICE_STATUS_DIC.PAID.value && o.status !== vm.$INVOICE_STATUS_DIC.CANCELED.value;
        o['editable'] = o.status !== vm.$INVOICE_STATUS_DIC.PAID.value && o.status !== vm.$INVOICE_STATUS_DIC.CANCELED.value && (vm.hasAdminAccess || o.type !== vm.$INVOICE_TYPE_DIC.SERVICE.value);
        o['cancellable'] = vm.$PAYABLE_INVOICE_STATUSES.includes(o.status) && (vm.hasAdminAccess || o.type !== vm.$INVOICE_TYPE_DIC.SERVICE.value);

        return o;
      }).concat(vm.lstObjects);
    },
    updatedObject(val) {
      const vm = this;

      if (val && typeof val === 'object') {
        val = new Array(val);
      }

      for (const v of val) {
        vm.lstObjects = vm.lstObjects.map(o => {
          if (o.id === v.id) {
            o.status = v.status;
            o.payment_date = v.payment_date;
            o.selectable = o.status !== vm.$INVOICE_STATUS_DIC.PAID.value && o.status !== vm.$INVOICE_STATUS_DIC.CANCELED.value;
            o.editable = o.status !== vm.$INVOICE_STATUS_DIC.PAID.value && o.status !== vm.$INVOICE_STATUS_DIC.CANCELED.value && (vm.hasAdminAccess || o.type !== vm.$INVOICE_TYPE_DIC.SERVICE.value);
            o.cancellable = vm.$PAYABLE_INVOICE_STATUSES.includes(o.status) && (vm.hasAdminAccess || o.type !== vm.$INVOICE_TYPE_DIC.SERVICE.value);
          }
          return o;
        });
      }
    },
    loadItems({ page, itemsPerPage, sortBy }) {
      const vm = this;

      if (vm.initialized) {
        if (sortBy?.length > 0) {
          vm.filters.orderBy = sortBy;
        } else {
          vm.filters.orderBy = null;
        }
        vm.submitSearch(page);
      }
    },
    cancel(invoices) {
      const vm = this;

      vm.invoicesToCancel = [];
      if (invoices?.length > 0 && !vm.requestingApi) {
        const cancelableInvoices = invoices.filter(invoice => vm.$PAYABLE_INVOICE_STATUSES.includes(invoice?.status));
        const data = {
          invoices_ids: cancelableInvoices.map(i => i.id),
          status: vm.$INVOICE_STATUS_DIC.CANCELED.value,
          validation: {
            total: cancelableInvoices.length
          }
        };

        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.invoice.writeOff(data)
            .then((result) => {
              const allCanceled = result?.canceled == invoices.length;

              result?.invoices?.forEach(i => vm.updatedObject(i));
              vm.selectedObjects = [];
              if (allCanceled) {
                vm.$notify({
                  type: "success",
                  text: result?.canceled > 1 ? "Lançamentos Cancelados" : "Lançamento Cancelado",
                });
              } else {
                vm.$notify({
                  type: "warn",
                  title: "Cancelamento Parcial",
                  text: `Apenas os lançamentos em situação "PENDENTE" e "VENCIDO" foram cancelados: Total ${result?.canceled}`,
                  duration: 5000
                });
              }
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "error",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    receipt(invoice) {
      const vm = this;

      if (invoice?.receipt_id) {
        if (!vm.requestingApi) {

          vm.requestingApi = true;
          return new Promise((resolve, reject) => {
            api.receipt.viewReceipt(invoice.receipt_id)
              .then((result) => {
                vm.currentInvoice = invoice;
                vm.receiptContent = result;
                vm.dialogReceipt = true;
              })
              .catch((err) => {
                if (err.message) {
                  vm.$notify({
                    type: "error",
                    text: err.message,
                  });
                }
              })
              .finally(() => {
                vm.requestingApi = false;
              });
          });
        }
      }
    },
    downloadReceipt() {
      const vm = this;

      if (vm.currentInvoice?.receipt_id) {
        if (!vm.requestingApi) {

          vm.requestingApi = true;
          return new Promise((resolve, reject) => {
            api.pdf.downloadReceipt(vm.currentInvoice.receipt_id)
              .then((result) => {
                // create file link inx browser's memory
                const href = URL.createObjectURL(result);

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;

                link.setAttribute('download', `Recibo_${vm.currentInvoice.receipt_id}_${vm.$moment(new Date()).format("YYYYMMDD-HHmmss")}.pdf`); //or any other extension
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
              })
              .catch((err) => {
                if (err.message) {
                  vm.$notify({
                    type: "error",
                    text: err.message,
                  });
                }
              })
              .finally(() => {
                vm.requestingApi = false;
              });
          });
        }
      }
    },
    printReceipt() {
      const vm = this;
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`<!DOCTYPE html>${vm.receiptContent}`);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    receiptClosed() {
      const vm = this;

      vm.currentInvoice = null;
      vm.receiptContent = '';
      vm.dialogReceipt = false;
    }
  },
  computed: {
    hasFinancialAccess() {
      const vm = this;

      return vm.hasGroupAdminAccess || vm.hasAdminAccess || vm.user?.access_level == vm.$USER_ACCESS_LEVELS_DIC.FINANCIAL_ADMIN.value;
    },
    hasGroupAdminAccess() {
      const vm = this;

      return vm.user?.access_level == vm.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value;
    },
    hasAdminAccess() {
      const vm = this;

      return vm.user?.access_level >= vm.$USER_ACCESS_LEVELS_DIC.ADMIN.value;
    },
    selectedItemsPayable() {
      const vm = this;
      const sizeRestriction = vm.selectedObjects.length <= 0;
      const serviceRestriction = !sizeRestriction && vm.selectedObjects.some(o => o.type === vm.$INVOICE_TYPE_DIC.SERVICE.value) && vm.selectedObjects.some(o => o.type !== vm.$INVOICE_TYPE_DIC.SERVICE.value);
      const statusRestriction = !sizeRestriction && vm.selectedObjects.some(o => !vm.$PAYABLE_INVOICE_STATUSES.includes(o.status));
      const eventRestriction = !sizeRestriction && vm.eventRestriction;

      return !sizeRestriction && !serviceRestriction && !statusRestriction && !eventRestriction;
    },
    eventRestriction(){
      const vm = this;

      return vm.selectedObjects.some(o => vm.shouldDisablePayment(o));
    },
    totalSum() {
      const vm = this;

      return vm.$filters.currency(vm?.lstObjects?.map(i => vm.getAmountFromInvoice(i)).reduce((p, c) => { return p + c; }, 0), 'BRL');
    }
  },
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_invoices_itemsPerPage"] = newVal;
    },
    "serverTable.page"(newVal) {
      var vm = this;

      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
    dialogReceipt(newVal) {
      const vm = this;

      if (newVal != null && !newVal) {
        vm.receiptClosed();
      }
    }
  },
};
</script>